
module dgUtils {

    function dgSelectOnClick($window: ng.IWindowService): ng.IDirective {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('click', function () {
                    if (!$window.getSelection().toString()) {
                        // Required for mobile Safari
                        this.setSelectionRange(0, this.value.length);
                    }
                });
            }
        };
    };
    dgSelectOnClick.$inject = [
        '$window'
    ];

    angular.module('dgUtils')
        .directive('dgSelectOnClick', dgSelectOnClick);
}